<template>
  <div>
    <div class="article-header">
      <div class="article-title">
        {{ collaboration.title }}
      </div>
      <div class="article-date">
        发布日期：{{ collaboration.date.slice(0, 4)}}年{{ collaboration.date.slice(5, 7)}}月{{ collaboration.date.slice(8, 10)}}日
      </div>
    </div>
    <div class="article-content">
      <div v-html="collaboration.content"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collaboration: ""
    };
  },
  created: function() {
    if (this.$route.query.type == "program") {
      this.get_collaboration_program_detail(this.$route.query.id);
    } else {
      this.get_collaboration_conference_detail(this.$route.query.id);
    }

  },
  methods: {
    get_collaboration_program_detail: function(id) {
      let url = "collaboration/programs/?id=" + id;
      this.$http.get(url).then(response => {
        this.collaboration = response.data.results[0];
      });
    },
    get_collaboration_conference_detail: function(id) {
      let url = "collaboration/conferences/?id=" + id;
      this.$http.get(url).then(response => {
        this.collaboration = response.data.results[0];
      });
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
